import $ from "jquery";

// Required if with multi value validation
// Required group - checks that at least one of several inputs has a value
$.validator.addMethod("requiredgroup", function (value, element, parameters) {

    // If this is an complex object we need to get the full name (example: User.Name.Firstname = User.Name )
    var modelPrefix = element.name.substr(0, element.name.lastIndexOf("."));

    var otherElements = $.map(parameters.othernames.split(","), function (otherName, index) {
        return modelPrefix ? $("[name='" + modelPrefix + "." + otherName + "']") : $("[name='" + otherName + "']");
    });

    var values = $.map(otherElements, function (otherElement) {
        return otherElement.val();
    })
    values.push(value);

    var hasValue = false;

    $.each(values, function (value) {
        if (!(this === null || this === "")) {
            hasValue = true;
        }
    });

    return hasValue;
});

$.validator.unobtrusive.adapters.add("requiredgroup", ["othernames"], function (options) {
    options.rules["requiredgroup"] = {
        othernames: options.params["othernames"],
    };
    options.messages["requiredgroup"] = options.message;
});